import { ROLES } from 'config/roles';
import DashboardShell from 'layouts/DashboardShell';

/** Mentor dashboard chrome — DashboardShell scoped to the mentor nav set. */
export default function MentorLayout() {
  return <DashboardShell role={ROLES.MENTOR} />;
}
